import React from 'react';

import Wrapper from 'components/wrapper';
import MetaTags from 'components/meta-tags';
import LayoutWithHeader from 'components/layouts/with-header';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import useUI from 'hooks/use-ui';

import { WhoopsProps } from './whoops.types';
import { WhoopsContent } from './content';

export function Whoops({ reason }: WhoopsProps): JSX.Element {
  const { isDutchieMain } = useUI();

  const Layout = isDutchieMain ? LayoutWithHeader : CoreMenuLayout;

  return (
    <Wrapper>
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <MetaTags customRobotsRule='noindex' variant='whoops' />
      <Layout>
        <WhoopsContent reason={reason} />
      </Layout>
    </Wrapper>
  );
}
